import React, { useState } from 'react'
import { useWatch } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import { AlertDialogSlide } from '@/components/AlertDialogSlide'
import { CustomField } from '@/components/Form/customFields/CustomField'
import { TextEditorField } from '@/components/Form/customFields/TextEditorField'
import CaluButton from '@/components/styledComponents/CaluButton'
import { deleteFragmentAdded, resetSelectedHCFragment } from '@/store/clinicHistoryFragments/actions'
import { Grid } from '@mui/material'

import s from '../styles.module.scss'

export const FormContent = ({ onClose, submitLoading = false, selectedFragment }) => {
  const { t } = useTranslation('global')
  const dispatch = useDispatch()
  const fieldName = useWatch({ name: 'name' })
  const fieldBody = useWatch({ name: 'body' })

  const [openAlertDelete, setOpenAlertDelete] = useState(false)

  const handleDisabledButton = () => {
    return !fieldName || !fieldBody
  }

  const deleteFragment = () => {
    dispatch(deleteFragmentAdded(selectedFragment._id))
    dispatch(resetSelectedHCFragment())
    onClose()
  }
  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <CustomField label="Nombre identificatorio *" name="name" fullWidth />
        </Grid>

        <Grid item xs={12} className={s.message}>
          <p>
            Para personalizar los fragmentos, puedes utilizar los siguientes campos variables:
            <br />
            <b>[apellido]</b>, <b>[nombre]</b>, <b>[DNI]</b>, <b>[{t('insuranceLabel.frag')}]</b>, <b>[nro-afiliado]</b>
            , <b>[edad]</b>
            <br />
            <br />
            Ejemplo: "El resultado del estudio del paciente [nombre] [apellido], [edad] años, está dentro de los
            parámetros normales."
          </p>
        </Grid>

        <Grid item xs={12}>
          <p className={s.labelEditor}>Campo del fragmento</p>
          <TextEditorField name="body" />
        </Grid>

        <Grid item xs={12}>
          <div className={s.divider}></div>
        </Grid>

        <Grid item xs={12} className={s.containerButtonsForm}>
          {selectedFragment && (
            <CaluButton size="medium" color="error" onClick={() => setOpenAlertDelete(!openAlertDelete)}>
              Eliminar
            </CaluButton>
          )}
          <CaluButton
            size="medium"
            color="primary"
            type="submit"
            loading={submitLoading}
            disabled={handleDisabledButton()}
          >
            Guardar
          </CaluButton>
        </Grid>
        <AlertDialogSlide
          open={openAlertDelete}
          setOpen={setOpenAlertDelete}
          textContent={'¿Realmente quiere eliminar este fragmento?'}
          textBackButton="Cancelar"
          textConfirmationButton={'Eliminar'}
          onClose={deleteFragment}
        />
      </Grid>
    </>
  )
}
